import cacheManager from'./CacheManager.js';let configuration = {};
function setCacheConfigurations(newConfiguration) {
    if (newConfiguration.driver) {
        cacheManager.setDriver(newConfiguration.driver);
    }
    if (newConfiguration.prefix) {
        cacheManager.getDriver().setPrefixKey(newConfiguration.prefix);
    }
    if (newConfiguration.valueConverter) {
        cacheManager.getDriver().setValueConverter(newConfiguration.valueConverter);
    }
    if (newConfiguration.valueParer) {
        cacheManager.getDriver().setValueParser(newConfiguration.valueParer);
    }
    configuration = { ...configuration, ...newConfiguration };
}
function getCacheConfigurations() {
    return configuration;
}
function getCacheConfig(key) {
    return configuration[key];
}export{getCacheConfig,getCacheConfigurations,setCacheConfigurations};